import React__default from 'react';
import { AkChevronDownCircleIcon } from '@fuegokit/fuegoicons-react';
import { StyledSelectItem, StyledSelect, StyledSelectTrigger, StyledSelectContent, StyledSelectViewport } from './styles.js';
import Box from '../../Box/Box.js';
import Select from '../../Select/Select.js';
import Text from '../../Text/Text.js';

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
/**
 * Displays a use case select item. Should be rendered inside a UseCaseSelect.
 */
const Item = ({
  children,
  disabled,
  description,
  onSelect,
  href,
  sx,
  testId,
  ...props
}) => {
  return /*#__PURE__*/React__default.createElement(StyledSelectItem, _extends({
    disabled: disabled,
    onSelect: onSelect,
    href: href,
    sx: sx
  }, props), /*#__PURE__*/React__default.createElement(Box, {
    sx: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-start'
    }
  }, /*#__PURE__*/React__default.createElement(Select.ItemText, {
    "data-testid": testId
  }, children), description ? /*#__PURE__*/React__default.createElement(Box, {
    as: "span"
  }, /*#__PURE__*/React__default.createElement(Text, {
    as: "p",
    color: disabled ? 'text.disabled' : 'text.subtlest',
    sx: {
      fontSize: 1,
      marginTop: 1,
      wordBreak: 'break-word'
    }
  }, description)) : null));
};
Item.displayName = "Item";
const UseCaseSelect = ({
  variant = 'default',
  options,
  spacing = 'default',
  placeholder,
  ariaLabel,
  children,
  value,
  onValueChange,
  trailingVisual: TrailingVisual,
  rotateTrigger = true,
  testId,
  ...props
}) => {
  const hasTrailingVisual = Boolean(TrailingVisual);
  return /*#__PURE__*/React__default.createElement(StyledSelect, _extends({
    value: value,
    onValueChange: onValueChange
  }, props), /*#__PURE__*/React__default.createElement(StyledSelectTrigger, {
    $variant: variant,
    $rotateTrigger: rotateTrigger,
    "aria-label": ariaLabel,
    "data-spacing": spacing,
    "data-testid": testId && `${testId}-trigger`
  }, /*#__PURE__*/React__default.createElement(Select.Value, {
    placeholder: placeholder
  }), /*#__PURE__*/React__default.createElement(Select.Icon, null, /*#__PURE__*/React__default.createElement(Box, null, hasTrailingVisual && typeof TrailingVisual === 'function' ? /*#__PURE__*/React__default.createElement(TrailingVisual, null) : /*#__PURE__*/React__default.createElement(AkChevronDownCircleIcon, null)))), /*#__PURE__*/React__default.createElement(Select.Portal, null, /*#__PURE__*/React__default.createElement(StyledSelectContent, {
    position: "popper"
  }, /*#__PURE__*/React__default.createElement(StyledSelectViewport, null, options ? options.map(option => {
    return /*#__PURE__*/React__default.createElement(Item, {
      key: option.id,
      value: option.label,
      testId: testId && `${testId}-item`
    }, option.label);
  }) : children))));
};
UseCaseSelect.displayName = "UseCaseSelect";
Item.displayName = 'Item';
UseCaseSelect.displayName = 'UseCaseSelect';
var UseCaseSelect$1 = Object.assign(UseCaseSelect, {
  Item
});

export { UseCaseSelect$1 as default };
